import { render, staticRenderFns } from "./PayrollInfoEmployerDealTotal.vue?vue&type=template&id=59aa2fde&"
import script from "./PayrollInfoEmployerDealTotal.vue?vue&type=script&lang=js&"
export * from "./PayrollInfoEmployerDealTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports